// src/pages/ToolsOverview.tsx
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  FaAddressBook,
  FaTools,
} from "react-icons/fa";

import { useCan } from "../authz/useCan";
import {
  LdsOverviewCard,
  LdsOverviewEmpty,
  LdsOverviewGrid,
  LdsOverviewHero,
  LdsOverviewPage,
  LdsOverviewSection,
} from "../components/lds/LdsOverview";

export default function ToolsOverview() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const canSeeDirectory = useCan("directory", "manage");
  // The bank account lookup moved to the Finance menu.
  const hasVisibleTiles = canSeeDirectory;

  return (
    <LdsOverviewPage>
      <LdsOverviewHero
        icon={FaTools}
        eyebrow={t("tools.overview.category", {
          defaultValue: "Tools",
        })}
        title={t("tools.overview.title", {
          defaultValue: "Tools",
        })}
        description={t("tools.overview.description", {
          defaultValue:
            "Useful tools for directory management and administrative lookups.",
        })}
      />

      {hasVisibleTiles ? (
        <LdsOverviewSection
          title={t("tools.overview.sections.title", {
            defaultValue: "Available tools",
          })}
          description={t("tools.overview.sections.description", {
            defaultValue:
              "Choose the tool you want to use.",
          })}
        >
          <LdsOverviewGrid>
            {canSeeDirectory ? (
              <LdsOverviewCard
                icon={FaAddressBook}
                eyebrow={t(
                  "tools.overview.cards.directory.category",
                  { defaultValue: "Directory" }
                )}
                title={t(
                  "tools.overview.cards.directory.title",
                  { defaultValue: "Directory" }
                )}
                description={t(
                  "tools.overview.cards.directory.description",
                  {
                    defaultValue:
                      "Manage published directory information.",
                  }
                )}
                actionLabel={t("common.open", {
                  defaultValue: "Open",
                })}
                onClick={() =>
                  navigate("/family/directory")
                }
                animationIndex={0}
              />
            ) : null}

          </LdsOverviewGrid>
        </LdsOverviewSection>
      ) : (
        <LdsOverviewEmpty>
          {t("tools.overview.empty", {
            defaultValue:
              "No tools are available with your current permissions.",
          })}
        </LdsOverviewEmpty>
      )}
    </LdsOverviewPage>
  );
}
